function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgStarLargeOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.098 21.452 12 18.349l5.901 3.103a.5.5 0 0 0 .726-.527L17.5 14.353 22.274 9.7a.5.5 0 0 0-.277-.853L15.4 7.888l-2.95-5.98a.5.5 0 0 0-.898 0l-2.95 5.98-6.599.958a.5.5 0 0 0-.277.853L6.5 14.353l-1.127 6.572a.5.5 0 0 0 .725.527Zm.53-1.638 5.36-2.819 5.361 2.819-1.023-5.97 4.337-4.228-5.994-.87-2.68-5.432-2.681 5.431-5.994.871 4.337 4.228-1.024 5.97Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgStarLargeOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgStarLargeOutlinedIcon);
export default Memo;